export class WorkorderFeedback {
  constructor(
    public readonly id: string,
    public readonly employeeId: string,
    public readonly answerType: 'questions'|'image',
    public readonly answer: {
      questions: QuestionAnswer[],
    } | {
      url: string
    },
    public readonly createdAt: Date,
    public readonly updatedAt: Date,
  ) {
  }

  public getUrl(): string|null {
    return 'url' in this.answer ? this.answer.url : null
  }

  public getQuestionAnswers(): QuestionAnswer[] {
    return 'questions' in this.answer ? this.answer.questions : []
  }

  static fromJson(json: any): WorkorderFeedback {
    return new WorkorderFeedback(
      json['id'],
      json['employee_id'],
      json['answer_type'],
      json['answer'],
      new Date(json['created_at']),
      new Date(json['updated_at']),
    )
  }
}

export class QuestionAnswer {
  constructor(
    public readonly answer: string|boolean,
    public readonly question: string,
    public readonly photos: string[]
  ) {
  }

  static fromJson(json: any): QuestionAnswer {
    return new QuestionAnswer(
      json['answer'],
      json['question'],
      json['photos'] ?? []
    )
  }
}